export default __webpack_public_path__ + "static/media/icons-mail-outline.864c77e1.svg";